const accotracStatus = "production";
let baseUrl = "";
if (accotracStatus === "production") {
  baseUrl = "https://accotracapi-test.joelmuhoho.com";
} else if (accotracStatus === "development") {
  baseUrl = "";
} else {
  baseUrl = "api";
}
export default baseUrl;
